export default __webpack_public_path__ + "static/media/supplier_management_orange.6406a424.svg";